// extracted by mini-css-extract-plugin
module.exports = {"container":"Article_container__143Rr","date":"Article_date__20UKP","text":"Article_text__4VBIu","gray":"Article_gray__2Kfs6"};